// http.ts
import { Toast } from 'vant';
import axios, { AxiosRequestHeaders } from 'axios';

import { commonParams, getPosition } from '@/common/utils';
import { checkBridge } from '@/common/jsBridgeUtils';
import { I18nTranslate } from '@/i18n';
// eslint-disable-next-line
import { checkLogin } from '@/common/login';
import omega from '@/common/omega';

// 设置请求头和请求路径
axios.defaults.baseURL = '';
axios.defaults.timeout = 10000;
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8

axios.interceptors.request.use(
  async config => {
    // 检测是否h5 通过bridge检测
    const inH5 = !checkBridge('exitLogin');
    const commonParam = commonParams();
    let position: any = null;

    try {
      position = await getPosition;
    } finally {
      // console.log(commonParam)
      if (config.method && config.method.toLowerCase() === 'post') {
        config.withCredentials = false;
        if (config?.headers?.['Content-Type'] === 'multipart/form-data') {
          // 文件上传会使用到
          config?.data?.append('ticket', commonParam?.ticket);
          config?.data?.append('location_country', commonParam?.location_country);
        } else if (config?.headers?.['Content-Type'] === 'application/json') {
          config.data = {
            ...(config?.data || {}),
            ...commonParam,
            ...(inH5 && commonParam?.lng ? {} : position || {})
          };
        } else {
          config.data = new URLSearchParams({
            ...(config?.data || {}),
            ...commonParam,
            ...(inH5 && commonParam?.lng ? {} : position || {})
          });
        }
      } else {
        config.withCredentials = false;
        config.params = {
          ...(config?.params || {}),
          ...commonParam,
          ...(inH5 && commonParam?.lng ? {} : position || {})
        };
      }
    }
    return config;
  },
  error => {
    // 请求失败处理
    Promise.reject(error);
    // return error
  }
);

// 响应拦截
axios.interceptors.response.use(
  res => {
    if (res?.data?.errno === 10005 || res?.data?.errno === 7002) {
      // 未登陆
      checkLogin(() => {});
      return res;
    }
    if (res?.data?.errno === 0) {
      // sessionStorage.setItem('token', '')
      // token过期操作
      return res;
    }
    console.error('error', res?.data?.errmsg);
    Toast(res?.data?.errmsg);
    const { config } = res;

    omega.traceApiError(config?.baseURL || '', {
      path: config?.url || '',
      params: config?.params || config?.data,
      status: res?.status,
      code: res?.data?.errno,
      msg: res?.data?.errmsg || '',
      trace_id: res?.data?.traceId || ''
    });
    return Promise.reject(res);
  },
  error => {
    console.log(error);
    Toast(I18nTranslate('Fleet_replenish__dJdA'));
    const { config } = error;

    omega.traceApiError(config?.baseURL || '', {
      path: config?.url || '',
      params: config?.params || config?.data,
      status: error?.response?.status || error?.status,
      code: error?.data?.errno || error?.code,
      msg: error?.data?.errmsg || error?.message,
      trace_id: error?.data?.traceId || ''
    });
    return Promise.reject(error);
  }
);

interface ResType<T> {
  code: number;
  data?: T;
  msg: string;
  err?: string;
}
interface Http {
  get<T>(url: string, params?: unknown): Promise<ResType<T>>;
  post<T>(url: string, params?: unknown, header?: AxiosRequestHeaders): Promise<ResType<T>>;
  upload<T>(url: string, params: unknown): Promise<ResType<T>>;
  download(url: string): void;
}

const http: Http = {
  get(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, { params })
        .then(res => {
          resolve(res?.data);
        })
        .catch(err => {
          reject(err?.data);
        });
    });
  },
  post(url, params: any, header) {
    return new Promise((resolve, reject) => {
      const postData = params;

      axios
        .post(url, postData, { headers: header })
        // .post(url, postData)
        .then(res => {
          resolve(res?.data);
        })
        .catch(err => {
          reject(err?.data);
        });
    });
  },
  upload(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(res => {
          resolve(res?.data);
        })
        .catch(err => {
          reject(err?.data);
        });
    });
  },
  download(url) {
    const iframe = document.createElement('iframe');

    iframe.style.display = 'none';
    iframe.src = url;
    iframe.onload = function () {
      document.body.removeChild(iframe);
    };
    document.body.appendChild(iframe);
  }
};

export default http;
